<template>
    <span class="navigator-token-badge">
        <a :href="`/tokens/${mint}`" class="navigator-token-badge__link">
            <span class="navigator-token-badge__symbol">{{ symbol }}</span>
            <span v-if="price" class="navigator-token-badge__price">{{ price }}</span>
            <span v-if="change" class="navigator-token-badge__change" :class="changeClass">{{ change }}</span>
        </a>
    </span>
</template>

<script>
import { computed } from 'vue';

export default {
    name: 'NavigatorTokenBadge',
    props: {
        mint: { type: String, default: '' },
        symbol: { type: String, default: '' },
        price: { type: String, default: '' },
        change: { type: String, default: '' },
    },
    setup(props) {
        const changeClass = computed(() => {
            if (!props.change) return '';
            return props.change.startsWith('+')
                ? 'navigator-token-badge__change--positive'
                : props.change.startsWith('-')
                    ? 'navigator-token-badge__change--negative'
                    : '';
        });
        return { changeClass };
    },
};
</script>

<style scoped>
.navigator-token-badge {
    display: inline-flex;
}

.navigator-token-badge__link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(139, 92, 246, 0.08);
    border: 1px solid rgba(139, 92, 246, 0.15);
    border-radius: 6px;
    padding: 2px 8px;
    text-decoration: none;
    transition: all 0.15s;
}

.navigator-token-badge__link:hover {
    background: rgba(139, 92, 246, 0.15);
    border-color: rgba(139, 92, 246, 0.3);
}

.navigator-token-badge__symbol {
    font-weight: 700;
    color: #e5e7eb;
    font-size: 13px;
}

.navigator-token-badge__price {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #d1d5db;
}

.navigator-token-badge__change {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
}

.navigator-token-badge__change--positive { color: #22c55e; }
.navigator-token-badge__change--negative { color: #ef4444; }
</style>
